<template>
  <generic-container
    :title="$t('datasource queries')"
    icon="database"
    :header_buttons="header_buttons"
  >
    <div class="ui three cards">
      <div class="card" v-for="(query, idx) in queries" :key="idx">
        <div class="content">
          <!-- <div class="header">{{ query.name }}</div>
          <div class="description">
            {{ $t("from datasource") }}
            <b>{{ get_datasource_name(query.datasource)}}</b>
          </div>-->
          <div class="ui form">
            <div class="field">
              <label for>{{ $t("name") }}</label>
              <div class="ui left icon input">
                <input type="text" name="name" v-model="queries[idx].name" />
                <i class="info icon"></i>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("datasource") }}</label>
              <select
                class="ui selection dropdown"
                ref="datasource_dropdown"
                v-model="queries[idx].datasource"
                :data-idx="idx"
              ></select>
              <!-- <div class="ui selection dropdown" ref="datasource_dropdown" :data-idx="idx">
                <input type="hidden" name="datasource" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>-->
            </div>
          </div>
        </div>
        <div class="ui bottom attached two buttons">
          <div
            class="ui basic icon button"
            :data-tooltip="$t('query builder')"
            @click="query_builder(query, idx)"
          >
            <i class="calculator icon"></i>
            {{ $t("query") }}
          </div>
          <div class="ui basic icon button" @click="remove(query, idx)">
            <i class="red trash icon"></i>
            {{ $t("delete") }}
          </div>
        </div>
      </div>
    </div>
    <template v-for="(mdl, index) in query_builder_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
        :input_query="selected_query"
        :datasources="datasources"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import QueryBuilderModal from "./QueryBuilderModal";
import { cloneDeep } from "lodash";

export default {
  name: "DatasourceConfiguration",
  components: { GenericContainer },
  props: {
    datasources: Array,
    queries: Array
  },
  data() {
    return {
      header_buttons: [
        {
          icon: "green plus",
          tooltip: this.$t("new query"),
          click: this.create
        }
      ],
      // queries: [],
      query_builder_modals: [],
      selected_query: undefined,
      selected_datasource: undefined
    };
  },
  methods: {
    create() {
      let vm = this;
      vm.queries.push({
        name: "query" + vm.queries.length,
        datasource: "",
        query: "",
        args: ""
      });
    },
    query_builder(query) {
      if (query.datasource) {
        this.selected_query = cloneDeep(query);
        this.query_builder_modals.push(QueryBuilderModal);
      } else this.$alertify.warning(this.$t("select datasource first"));
    },
    destroy() {
      this.query_builder_modals = [];
      this.selected_query = undefined;
    },
    succedded(data) {
      let vm = this;
      let trgtQry = vm.queries.find(q => q.name == data.query.name);
      if (trgtQry) {
        trgtQry.query = data.sql;
        trgtQry.args = data.args;
      }
      // this.destroy();
    },
    get_queries() {
      return this.queries || [];
    },
    get_datasource_name(dsuuid) {
      let trgt = this.datasources.find(ds => ds.uuid == dsuuid);
      let r = trgt ? trgt.name : "¿?";
      return r;
    },
    remove(query, index) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove query?"), function() {
        vm.queries.splice(index, 1);
      });
    }
  },
  created() {},
  mounted() {
    window.jQuery(".ui.accordion").accordion();
  },
  watch: {
    queries() {
      let vm = this;
      window.jQuery(".ui.accordion").accordion();

      let vls = vm.datasources.map(d => {
        return {
          name: d.name,
          value: d.uuid
        };
      });

      setTimeout(() => {
        vm.$refs.datasource_dropdown.map((dd, ix) => {
          let ddd = window
            .jQuery(dd)
            .dropdown({
              onChange(value) {
                let idx = window.jQuery(this).data("idx");
                if (idx >= 0) vm.queries[idx].datasource = value;
              }
            })
            .dropdown("setup menu", { values: vls });

          let qry = vm.queries[ix];

          if (qry.datasource) {
            ddd.dropdown("set selected", qry.datasource);
          }
          return dd;
        });
      }, 300);
    }
  }
};
</script>
